import type { GetSignoutResponse } from './types';

import { getGenericEndpoint } from './get.api';

export const getSignout = async (lang?: string) => {
    return await getGenericEndpoint<GetSignoutResponse>('signout', lang);
};
